const i = "pagination", a = "pagination__row", n = "pagination__item", t = "pagination__icon", o = "pagination__button", _ = "pagination__separator", p = {
  pagination: i,
  "pagination--has-margin-top": "pagination--has-margin-top",
  pagination__row: a,
  "pagination__large-numbers": "pagination__large-numbers",
  "pagination__small-numbers": "pagination__small-numbers",
  pagination__item: n,
  "pagination__item--colored": "pagination__item--colored",
  "pagination__item--active": "pagination__item--active",
  "pagination__item-text": "pagination__item-text",
  "pagination__item--disabled": "pagination__item--disabled",
  pagination__icon: t,
  pagination__button: o,
  pagination__separator: _,
  "pagination__visually-hidden": "pagination__visually-hidden"
};
export {
  p as default,
  i as pagination,
  o as pagination__button,
  t as pagination__icon,
  n as pagination__item,
  a as pagination__row,
  _ as pagination__separator
};
